import { frontendURL } from '../../../../helper/URLHelper';
import KanbanBoardSettings from './pages/KanbanBoardSettings.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/kanban-board'),
      name: 'settings_kanban_board',
      roles: ['administrator', 'custom_role'],
      component: KanbanBoardSettings,
      props: true,
      meta: {
        permissions: ['administrator', 'custom_role'],
      },
    },
  ],
};
